import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("submit", this.showNotification.bind(this))
  }

  showNotification(event) {
    // Show a toast notification
    const toast = document.createElement("div")
    toast.className = "toast toast-top toast-center z-50"
    toast.innerHTML = `
      <div class="alert alert-info">
        <span class="loading loading-spinner loading-sm"></span>
        <span>Recalculating report with current rates. You'll be redirected when it's ready...</span>
      </div>
    `
    document.body.appendChild(toast)
  }
}
